// extracted by mini-css-extract-plugin
export default {"value":"sn4VB","value--cut":"Y8eup","value--max":"aBVEg","value__strong":"oTDAo"};